export const A11yElementId = {
  MAIN_NAVIGATION: 'main-navigation',
} as const;

export interface IA11yService {
  focusElement(elementId: string): void;
  registerElement(elementId: string, element: HTMLElement): void;
  unregisterElement(elementId: string): void;
}

export class A11yService implements IA11yService {
  private readonly _registeredElements: Map<string, WeakRef<HTMLElement>> = new Map();

  constructor() {
    window.$app.logger.log('A11yService initialized');
  }

  public focusElement(elementId: string): void {
    window.$app.logger.log(`A11yService: focusElement '${elementId}'`);
    const ref = this._registeredElements.get(elementId);
    const element = ref?.deref();
    if (!element) {
      if (ref) this._registeredElements.delete(elementId);
      window.$app.logger.error(
        `A11yService: focusElement '${elementId}' not registered!`,
        `'${elementId}' not registered!`,
      );
      return;
    }
    element.focus();
  }

  public registerElement(elementId: string, element: HTMLElement): void {
    window.$app.logger.log(`A11yService: registerElement '${elementId}'`);
    this._registeredElements.set(elementId, new WeakRef(element));
  }

  public hasElement(elementId: string): boolean {
    const ref = this._registeredElements.get(elementId);
    if (!ref) return false;
    if (!ref.deref()) {
      this._registeredElements.delete(elementId);
      return false;
    }
    return true;
  }

  public unregisterElement(elementId: string): void {
    window.$app.logger.log(`A11yService: unregisterElement '${elementId}'`);
    this._registeredElements.delete(elementId);
  }
}
